import React from "react";
import userData from "../../userdata.json";
import LottieAnimation from "../loties-animation";
const EducationConatainer = ({ edu }) => {
  return (
    <div className="container relative container-education mb5 pointer">
      <div className="w-100 relative">
        <div className={`flex items-center flex-row-reverse period-line`}>
          <div className={`f4-l f5 w-70 ml3`}><b>{edu?.period || ""}</b></div>
          <hr className="pv0 mv0 mh0 w-30 b--primary ba" />
        </div>
        <div className={"ml5-l ml4 "}>
          <div className="f3-l f4 mt3 flex db-l flex-column items-center justify-center text-align-none-l text-align-center">
            <b>{edu?.course || ""}</b>

            <div className="f4 mt3">{edu?.school || ""}</div>
          </div>
          <ul className="ph3">
            {(edu?.achivments || []).map((point) => (
              <li>{point}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

const Education = () => {
  const { education } = userData;
  return (
    <div id="Education" className="pt6" >
      <div className=" f1 flex">
        <hr className="w-50" />
        <span className="mh3">Education</span>
        <hr className="w-50" />
      </div>
      <div className="flex flex-column-reverse flex-row-l w-100 mt5">
        <div className="w-50-l">
        <LottieAnimation name="five" />
        </div>
        <div className=" w-50-l timeline-education relative">
          {(education || []).map((edu, index) => (
            <EducationConatainer edu={edu} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Education;
